import { useEffect } from 'react';

import { PaywallScreens } from '~analytics/types';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';

interface DisplayQuizLimitPaywallParams {
  quizLimitReachedTime: number;
  paywallDispatch: PaywallDispatch;
}

export function DisplayQuizLimitPaywall({
  quizLimitReachedTime,
  paywallDispatch,
}: DisplayQuizLimitPaywallParams) {
  useEffect(() => {
    if (quizLimitReachedTime == null) return;

    paywallDispatch({
      type: 'OPEN',
      touch: [
        PaywallScreens.QuizListLimitReached,
        PaywallScreens.QuizListImportQuiz,
      ],
    });
  }, [quizLimitReachedTime, paywallDispatch]);

  return null;
}
